import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import InputAdornment from '@mui/material/InputAdornment';
import api, { errMsg } from '../api/client';

const NewProjectDialog = ({ open, onClose, onCreated }) => {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    name: '',
    siteAddress: '',
    budgetTotal: '',
    clientName: '',
    clientPhone: '',
  });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = async () => {
    setError('');
    setBusy(true);
    try {
      const { data } = await api.post('/api/projects', {
        name: form.name,
        siteAddress: form.siteAddress || undefined,
        budgetTotal: form.budgetTotal ? Number(form.budgetTotal) : undefined,
        clientName: form.clientName || undefined,
        clientPhone: form.clientPhone || undefined,
      });
      setForm({ name: '', siteAddress: '', budgetTotal: '', clientName: '', clientPhone: '' });
      onCreated(data);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t('home.newProject')}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField label={t('project.name')} value={form.name} onChange={set('name')} autoFocus />
          <TextField label={t('project.siteAddress')} value={form.siteAddress} onChange={set('siteAddress')} />
          <TextField
            label={t('project.budget')}
            value={form.budgetTotal}
            onChange={(e) => setForm({ ...form, budgetTotal: e.target.value.replace(/[^\d]/g, '') })}
            type="tel"
            InputProps={{ startAdornment: <InputAdornment position="start">₹</InputAdornment> }}
          />
          <TextField label={t('project.clientName')} value={form.clientName} onChange={set('clientName')} />
          <TextField
            label={t('project.clientPhone')}
            value={form.clientPhone}
            onChange={(e) =>
              setForm({ ...form, clientPhone: e.target.value.replace(/[^\d]/g, '').slice(0, 10) })
            }
            type="tel"
            helperText={t('project.clientPhoneHelp')}
            InputProps={{ startAdornment: <InputAdornment position="start">+91</InputAdornment> }}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
        <Button variant="contained" disabled={!form.name.trim() || busy} onClick={submit}>
          {t('project.create')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewProjectDialog;
